import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../assests/css/students/ExamCards.css';
import { FileText, BookOpen, ClipboardList } from 'lucide-react';

const ExamCards = () => {
  const [activeCard, setActiveCard] = useState(null);
  const navigate = useNavigate();

  const cards = [
    {
      id: 1,
      title: "Download & Access",
      description: "Download notes for your exams",
      icon: <FileText size={52} />,
      path: "/Student-files"
    },
    {
      id: 2,
      title: "Datesheet",
      description: "Access your datesheet to view and Download.",
      icon: <ClipboardList size={52} />,
      path: "/student/datsheet"
    },
    {
      id: 3,
      title: "Result",
      description: "View your exam result sheet",
      icon: <BookOpen size={52} />,
      path: "/student/result-card"
    },
  ];

  const handleCardClick = (cardId, path) => {
    setActiveCard(cardId);
    navigate(path);
  };

  return (
    <div className="ec-exam-container">
      <div className="ec-exam-header">
        <h1>Examination</h1>
        <p>Make exam preparation easier with useful tools and resources for students.
</p>
      </div>

      <div className="ec-cards-wrapper">
        <div className="ec-cards-row">
          {cards.map((card) => (
            <div
              key={card.id}
              className={`ec-exam-card ${activeCard === card.id ? 'ec-active' : ''}`}
              onClick={() => handleCardClick(card.id, card.path)}
            >
              <div className="ec-card-icon">{card.icon}</div>
              <h3 className="ec-card-title">{card.title}</h3>
              <p className="ec-card-description">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExamCards;